import { useEffect, useState } from 'react';
import api from '../services/api';

export default function CompanyLogo({ companyId, name, hasLogo, className = 'h-8 w-8' }: { companyId: string; name: string; hasLogo?: boolean; className?: string }) {
  const [src, setSrc] = useState<string | null>(null);

  useEffect(() => {
    if (!hasLogo) {
      setSrc(null);
      return;
    }
    let active = true;
    let objectUrl: string | null = null;
    void api
      .get<Blob>(`/customer/companies/${companyId}/logo`, { responseType: 'blob' })
      .then(({ data }) => {
        if (!active) return;
        objectUrl = URL.createObjectURL(data);
        setSrc(objectUrl);
      })
      .catch(() => active && setSrc(null));
    return () => {
      active = false;
      if (objectUrl) URL.revokeObjectURL(objectUrl);
    };
  }, [companyId, hasLogo]);

  return (
    <span role="img" aria-label={`${name} logo`} className={`inline-flex shrink-0 items-center justify-center overflow-hidden rounded-lg bg-[#fdf2f8] font-black text-[#d6006e] ${className}`}>
      {src ? <img src={src} alt={`${name} logo`} className="h-full w-full object-contain" /> : name.slice(0, 1).toUpperCase() || '?'}
    </span>
  );
}